export const fontSourcePro = 'Source Sans Pro' || 'SourceSansPro-Bold';
export const fontKarla = 'Karla' || 'Karla-Regular';
export const publicSans = 'Public Sans';
export const beVietnam = 'Be Vietnam';
